'use client'

import FilterItemBase, { FilterItemSpan, PopupContent } from '../../base'
import { isBoolean, size } from 'lodash-es'
import { HOUSE_FILTER_ALIAS } from '@config'
import FilterItemNormal from '../../base/normal'
import useItem from '../useItem'
import { useBoolean } from 'react-use'
import { useCallback, useEffect } from 'react'
import AppendRoot from '@component/appendRoot'
import FullPopup from '@component/fullPopup'
import { useRecoilValue } from 'recoil'
import { global } from '@store/index'

export default function FilterPropertyType() {

  const { isMobile } = useRecoilValue(global)
  const [mobile, toggleMobile] = useBoolean(false)
  useEffect(() => {
    toggleMobile(isMobile)
  }, [isMobile, toggleMobile])

  // 是否显示Popup
  const [open, togglOpen] = useBoolean(false)
  const displayPopup = useCallback(visiable => {
    togglOpen(isBoolean(visiable) ? visiable : undefined)
  }, [togglOpen])

  const {
    textLabel,
    routeData,
    viewData,
    isLoading,
    value,
    state,
    resetValue,
    changeHandle,
    clearHandle,
    confirmHandle
  } = useItem({
    text: 'Property type',
    slugKey: 'property-type',
    houseRouteKey: 'property-type',
    alias: HOUSE_FILTER_ALIAS.propertyType,
    isSlug: true
  })

  const closePopup = useCallback(() => {
    resetValue()
    displayPopup(false)
  }, [displayPopup, resetValue])
  const confirmPopup = useCallback(() => {
    confirmHandle()
    displayPopup(false)
  }, [displayPopup, confirmHandle])

  if (mobile) return null

  return (
    mobile
      ? <div className='flex-1 relative after:w-2 after:h-16 after:bg-neutral after:absolute after:right-0 after:top-1/2 after:-translate-y-1/2'>
        <FilterItemSpan
          active={!!size(routeData)}
          onClick={displayPopup}
        >
          Property types
        </FilterItemSpan>
        <AppendRoot>
          <FullPopup show={open} smCenter mobileFull maskCloseable onClose={displayPopup} contentClassName='!bg-transparent'>
            <div className='w-screen h-fill-screen bg-white sm:max-w-[94vw] sm:w-[800px] sm:h-auto sm:rounded-sm'>
              <PopupContent
                className='flex flex-col h-fill-screen max-h-fill-screen !py-16 sm:!py-24 sm:px-24 sm:h-[640px] sm:max-h-[80vh]'
                contentClassName='flex-1 min-h-0 overflow-auto -mx-16 sm:-mx-24 px-16 sm:px-24'
                title='Property types'
                totals={viewData && viewData.totals}
                isLoading={isLoading}
                closeable
                onClose={closePopup}
                onClear={clearHandle}
                onConfirm={confirmPopup}
              >
                {viewData && <FilterItemNormal value={value} data={viewData} state={state} onChange={changeHandle} twoCols isSlug></FilterItemNormal>}
              </PopupContent>
            </div>
          </FullPopup>
        </AppendRoot>
      </div>
      : (
        <FilterItemBase
          right
          text={textLabel}
          popupTitle='Property types'
          active={!!size(routeData)}
          totals={viewData && viewData.totals}
          isLoading={isLoading}
          onClear={clearHandle}
          onClose={resetValue}
          onConfirm={confirmHandle}
        >
          {viewData && <FilterItemNormal value={value} data={viewData} state={state} onChange={changeHandle} twoCols isSlug></FilterItemNormal>}
        </FilterItemBase>
      )
  )
}
